import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import moment from "moment";
import { ParametresInstance } from "../../Controls/Parameters";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { AjoutPeriodeVariableParam } from "../../../shared/interfaces/ajoutPeriodeVariable.interface";

interface dateChoisissable {
	date?: Date;
	libelle: string;
}

interface moisChoisissable {
    numero?: number;
    libelle: string;
}

@Component
export default class ModalAjoutPeriodeVariable extends Vue {
    public listeDateDebut: dateChoisissable[] = [];
    public listeMoisFin: moisChoisissable[] = [];
    public listeAnneesFin: string[] = [];

    public selectedDateLibelle = "";
    public selectedMoisLibelle = "";
    public selectedAnnee = "";

	public codeRubrique?: string = "";
	public codeNature?: string = "";
    public idContrat?: number;
    public idRubrique: number = 0;
    public selected = false;
    public codeVariable?: string;
    public value?: number;

    // -----------------------------------------------------

    public mounted(): void {
        const date = ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.PeriodeActive != undefined ? new Date(ParametresInstance.societeCourante.PeriodeActive.getUTCFullYear(), ParametresInstance.societeCourante.PeriodeActive.getUTCMonth(), 1) : new Date(new Date().getUTCFullYear(), new Date().getUTCMonth(), 1);

        this.setListeDateDebut(date);
        this.setListeMoisFin();
        this.setListeAnneesFin(date);
    }

    public setElementVariable(selected: boolean, idRubrique: number, idContrat?: number, codeRubrique?: string, codeNature?: string, codeVariable?: string, dateDebut?: Date, dateFin?: Date, value?: number): void {
    	this.codeRubrique = codeRubrique;
        this.codeNature = codeNature;
        this.codeVariable = codeVariable;
        this.idContrat = idContrat;
        this.idRubrique = idRubrique;
        this.selected = selected;
        this.value = value;

        this.setDateDebutEtFin(dateDebut, dateFin);

    	this.$forceUpdate();
	}

	public enregistrer(): void {
    	const selectedDate = this.listeDateDebut.filter(d => d.libelle == this.selectedDateLibelle)[0].date;
    	let dateDebut;
    	let dateFin;

        if (selectedDate != undefined) {

            dateDebut = this.createDateUtc(selectedDate.getUTCFullYear(), selectedDate.getUTCMonth(), 1);

            if (this.selectedAnnee != "" && this.selectedMoisLibelle != "") {
                const annee = parseInt(this.selectedAnnee);
                const mois = this.listeMoisFin.filter(m => m.libelle === this.selectedMoisLibelle)[0].numero;

                dateFin = new Date(annee, mois!, 0);
            } else if (!(this.selectedAnnee === "" && this.selectedMoisLibelle === "")) {
                NotificationServiceInstance.SendWarning("La date de fin de période doit être vide ou complète.");
                return;
            }
        }

        if (dateDebut > dateFin) {
            NotificationServiceInstance.SendWarning("La date de fin de période doit être supérieure à sa date de départ.");
            return;
        }

        const param: AjoutPeriodeVariableParam = {
            selected: this.selected,
            codeRubrique: this.codeRubrique,
            codeNature: this.codeNature,
            codeVariable: this.codeVariable,
            idContrat: this.idContrat,
            idRubrique: this.idRubrique,
            dateDebut: dateDebut,
            dateFin: dateFin,
            value: this.value
        };
        this.$emit("validate", param);

        this.close();
    	this.$forceUpdate();
	}

    private createDateUtc(year: number, month: number, date: number): Date {
        return new Date(Date.UTC(year, month, date));
    }

    private close(): void {
        this.selectedDateLibelle = "";
        this.selectedMoisLibelle = "";
        this.selectedAnnee = "";

        $("#modalAjoutPeriodeVariable").modal("hide");
    }

    private setListeDateDebut(date: Date): void {
        this.listeDateDebut.push({ date: undefined, libelle: "" });
        const dateCopy = new Date(date.getFullYear(), date.getMonth(), date.getDate());

        for (let i = 0; i < 12; i++) {
            const dateToAdd = dateCopy;
            this.listeDateDebut.push({ date: this.createDateUtc(dateToAdd.getFullYear(), dateToAdd.getMonth(), 1), libelle: moment(dateCopy).format("YYYY MMMM") });
            let month = dateCopy.getMonth();
            month++;
            dateCopy.setMonth(month, 1);
        }
    }

    private setListeMoisFin(): void {
        this.listeMoisFin.push(
            { numero: undefined, libelle: "" },
            { numero: 1, libelle: "Janvier" },
            { numero: 2, libelle: "Février" },
            { numero: 3, libelle: "Mars" },
            { numero: 4, libelle: "Avril" },
            { numero: 5, libelle: "Mai" },
            { numero: 6, libelle: "Juin" },
            { numero: 7, libelle: "Juillet" },
            { numero: 8, libelle: "Août" },
            { numero: 9, libelle: "Septembre" },
            { numero: 10, libelle: "Octobre" },
            { numero: 11, libelle: "Novembre" },
            { numero: 12, libelle: "Décembre" }
        );
    }

    private setListeAnneesFin(date: Date): void {
        const year = date.getFullYear();
        this.listeAnneesFin.push("");

        for (let i = year; i <= 2199; i++) {
            this.listeAnneesFin.push(i.toString());
        }
    }

    private setDateDebutEtFin(dateDebut?: Date, dateFin?: Date): void {
        if (dateDebut != undefined) {
            this.selectedDateLibelle = moment.utc(dateDebut).format("YYYY MMMM");

            if (dateFin != undefined) {
                const dateFinUtc = moment.utc(dateFin);
                this.selectedAnnee = dateFinUtc.format("YYYY");

                const month = dateFinUtc.format("MMMM");
                this.selectedMoisLibelle = month.charAt(0).toUpperCase() + month.slice(1);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/saisieDesVariables/modalAjoutPeriodeVariable/modalAjoutPeriodeVariable.ts